import { LogoutModalProps } from "../types/types";
import Button from "./elements/Button";
import Modal, { ModalContent } from "./elements/Modal";
import { TbLogout2 } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../redux/hooks";
import { logout } from "../redux/auth/authSlice";
import toast from "react-hot-toast";

const LogoutModal = ({ closeModal }: LogoutModalProps) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const logoutHandler = () => {
    try {
      dispatch(logout());
      navigate("/");
      toast.success("Logged out sucessfully!");
    } catch (error: any) {
      toast.error(error.message);
    }
  };

  return (
    <Modal
      open={true}
      onClose={closeModal}
      className="flex items-center justify-center p-4"
    >
      <ModalContent className="mx-auto p-8 md:p-10 rounded-2xl shadow-2xl flex flex-col justify-center items-center bg-white w-[90%] md:w-full max-w-md relative overflow-hidden transition-all">
        <div className="absolute top-0 left-0 w-full h-32 bg-gradient-to-b from-red-50 to-white -z-10 blur-xl"></div>

        <div className="bg-red-100 flex items-center justify-center text-red-600 h-16 w-16 rounded-full shadow-sm ring-8 ring-red-50 mb-6">
          <TbLogout2 className="w-8 h-8 ml-1" />
        </div>

        <div className="text-center space-y-2 mb-8">
          <h1 className="font-bold text-gray-900 text-xl tracking-tight">
            Log Out
          </h1>
          <p className="text-sm text-gray-500 font-medium">
            Are you sure you want to log out of your account?
          </p>
        </div>

        <div className="flex items-center justify-between w-full gap-3">
          <Button
            onClick={closeModal}
            className="flex-1 bg-white border border-gray-200 text-gray-700 hover:bg-gray-50 hover:text-gray-900 font-semibold py-3 px-4 rounded-xl transition-all duration-200"
          >
            Cancel
          </Button>
          <Button
            onClick={logoutHandler}
            className="flex-1 bg-red-600 text-white font-semibold py-3 px-4 hover:bg-red-700 hover:shadow-md hover:-translate-y-0.5 rounded-xl transition-all duration-200"
          >
            Log Out
          </Button>
        </div>
      </ModalContent>
    </Modal>
  );
};

export default LogoutModal;
